import { createContext, useContext, useEffect, useState } from "react";

const UIContext = createContext({ heroDark: false, setHeroDark: () => {}, menuOpen: false, setMenuOpen: () => {} });

export function UIProvider({ children }) {
  const [heroDark, setHeroDark] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  return <UIContext.Provider value={{ heroDark, setHeroDark, menuOpen, setMenuOpen }}>{children}</UIContext.Provider>;
}

export function useUI() {
  return useContext(UIContext);
}

/** Mark the current page as having a dark hero (header renders light at the top) */
export function useDarkHero() {
  const { setHeroDark } = useUI();
  useEffect(() => {
    setHeroDark(true);
    return () => setHeroDark(false);
  }, [setHeroDark]);
}
